import moment from 'moment';
import 'moment/locale/it';
import 'moment/locale/fr';
import { DateTimeFormat, formatListPerLocale } from './formats';
export { DateTimeFormat };
export function formatDateFactory(_a) {
    var momentDateFactory = _a.momentDateFactory;
    return function formatDate(_a) {
        var locale = _a.locale, date = _a.date, format = _a.format, _b = _a.fallback, fallback = _b === void 0 ? '' : _b;
        if (!date) {
            return fallback;
        }
        var mValue = date instanceof moment ? date : momentDateFactory(date);
        mValue.locale(locale);
        return mValue.isValid() ? mValue.format(getFormat({ locale: locale, format: format })) : fallback;
    };
}
export var formatUTCDate = formatDateFactory({ momentDateFactory: moment.utc });
export var formatLocalDate = formatDateFactory({ momentDateFactory: moment });
function getFormat(_a) {
    var locale = _a.locale, format = _a.format;
    var formatList = getFormatList(locale);
    var formatResult = formatList[format];
    if (!formatResult) {
        throw new Error("The format \"".concat(format, "\" does not exist"));
    }
    return formatResult;
}
function getFormatList(locale) {
    if (formatListPerLocale[locale]) {
        return formatListPerLocale[locale];
    }
    var language = locale.split('-')[0];
    if (formatListPerLocale[language]) {
        return formatListPerLocale[language];
    }
    throw new Error("No formats found for the \"".concat(locale, "\" locale"));
}
export var timezone = {
    FR: 'Europe/Paris',
    IT: 'Europe/Rome',
    US: 'America/New_York',
};
